module.exports = __webpack_public_path__ + "img/Newspaper.b18ca96d.jpg";